import React, { useEffect, useState } from "react";
import axios from "axios";
import "../styles/EvrakPopup.css";
import UyariPopup from "../components/UyariPopup";

const EvrakPopup = ({ onClose }) => {
  const [evraklar, setEvraklar] = useState([]);
  const [detayEvrak, setDetayEvrak] = useState(null);
  const token = localStorage.getItem("token");
  const [selectedFile, setSelectedFile] = useState(null);
  const [previewName, setPreviewName] = useState("");
  const [warning, setWarning] = useState(null);
  const [isUploading, setIsUploading] = useState(false);

  const isMobile = window.innerWidth <= 600;

  const handleFileSelect = (e) => {
    const file = e.target.files[0]; // önce dosyayı al
    if (file) {
      setSelectedFile(file);
      setPreviewName(file.name);
    }

    e.target.value = null; // sonra sıfırla (iOS için)
  };


  const handleUpload = async () => {
    if (!selectedFile || !detayEvrak) {
      setWarning({
        title: "Uyarı",
        message: "❗ Lütfen önce bir dosya seçin.",
        type: "warning",
      });
      return;
    }

    setIsUploading(true); // 🔵 Başlarken

    const formData = new FormData();
    formData.append("EvrakId", detayEvrak.evrakId);
    formData.append("Dosya", selectedFile);

    try {
      await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/Evrak/evrakyukle`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data"
        }
      });
      setWarning({
        title: "Başarılı",
        message: "✅ Evrak yüklendi!",
        type: "success",
      });
      setDetayEvrak(null);
      setSelectedFile(null);
      setPreviewName("");
      fetchEvraklar();
    } catch (err) {
      setWarning({
        title: "Hata",
        message: "❌ Evrak yüklenemedi!",
        type: "error",
      });
    } finally {
      setIsUploading(false); // 🔴 İşlem bittiğinde
    }
  };


  useEffect(() => {
    fetchEvraklar();
  }, []);

  const fetchEvraklar = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/Evrak/evraklarim`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setEvraklar(res.data.$values || []);
    } catch (err) {
      console.error("❌ Evraklar alınamadı:", err);
    }
  };

  const evrakOnaylandi = detayEvrak && detayEvrak.durum?.toLowerCase() === "onaylandi";

  return (
    <div className="modal-overlay">
      <div className="evrak-popup">
        <button className="evrak-close-btn" onClick={onClose}>✖</button>
        <h3 className="evrak-title">Gerekli Evraklar</h3>

        {!detayEvrak && (
          <>
            {!isMobile && (
              <div className="evrak-header">
                <div className="evrak-col">Evrak Adı</div>
                <div className="evrak-col">Teslim Tarihi</div>
                <div className="evrak-col">Yükleme Durumu</div>
                <div className="evrak-col">İnceleme Durumu</div>
                <div className="evrak-col"></div>
              </div>
            )}
            <ul className="evrak-list">
              {evraklar.map((evrak, i) => (
                <li key={i} className={`evrak-item ${isMobile ? "mobile-row" : "desktop-row"}`}>
                  <div className="evrak-col" data-label="Evrak Adı : "><strong>{evrak.ad}</strong></div>
                  <div className="evrak-col" data-label="Teslim Tarihi : ">{new Date(evrak.sonTeslimTarihi).toLocaleDateString("tr-TR")}</div>
                  <div className="evrak-col" data-label="Yükleme Durumu : ">
                    <span className={evrak.yuklemeDurumu === "Yüklendi" ? "evrak-durum-yes" : "evrak-durum-no"}>
                      {evrak.yuklemeDurumu}
                    </span>
                  </div>
                  <div className="evrak-col" data-label="İnceleme Durumu">
                    <span className={
                      evrak.durum === "Onaylandi" ? "evrak-durum-yes" :
                        evrak.durum === "Reddedildi" ? "evrak-durum-red" :
                          "evrak-durum-waiting"
                    }>
                      {evrak.durum}
                    </span>
                  </div>

                  <button
                    className="evrak-detay-btn"
                    onClick={() => {
                      console.log("🧪 Seçilen evrak:", evrak);
                      setDetayEvrak(evrak);
                    }}
                  >
                    Detay Gör
                  </button>
                </li>
              ))}
            </ul>
          </>
        )}

        {detayEvrak && (
          <div className="evrak-detay-popup">
            <div className="evrak-detay-row">
              <span className="etiket">Evrak Adı : </span><span>{detayEvrak.ad}</span>
            </div>
            <div className="evrak-detay-row">
              <span className="etiket">Açıklama : </span><span>{detayEvrak.aciklama}</span>
            </div>
            <div className="evrak-detay-row">
              <span className="etiket">Talep Tarihi : </span><span>{new Date(detayEvrak.talepTarihi).toLocaleDateString("tr-TR")}</span>
            </div>
            <div className="evrak-detay-row">
              <span className="etiket">Son Teslim Tarihi : </span><span>{new Date(detayEvrak.sonTeslimTarihi).toLocaleDateString("tr-TR")}</span>
            </div>

            <div className="evrak-detay-row">
              <span className="etiket">Seçilen Dosya : </span>
              <span>{previewName || "Henüz dosya seçilmedi."}</span>
            </div>

            {/* ✅ Yüklenen dosya varsa "Dosyayı Gör" butonu göster */}
            {detayEvrak.yuklemeDurumu === "Yüklendi" && (
              <div className="evrak-detay-row">
                <button
                  className="evrak-dosya-gor-btn"
                  onClick={async () => {
                    try {
                      const response = await axios.get(
                        `${process.env.REACT_APP_API_BASE_URL}/api/Evrak/dosya?id=${detayEvrak.evrakId}`,
                        {
                          headers: {
                            Authorization: `Bearer ${token}`,
                          },
                          responseType: "blob", // 🔹 blob şart
                        }
                      );

                      const contentType = response.headers["content-type"]; // 🔹 tipi al
                      const blob = new Blob([response.data], { type: contentType });
                      const url = window.URL.createObjectURL(blob);
                      window.open(url, "_blank");
                    } catch (error) {
                      setWarning({
                        title: "Görüntüleme Hatası",
                        message: "❌ Dosya görüntülenemedi!",
                        type: "error",
                      });
                      console.error(error);
                    }
                  }}
                >
                  Dosyayı Gör
                </button>
              </div>
            )}

            <div className="evrak-upload-row">
              <label
                className="evrak-upload-btn"
                style={{
                  opacity: evrakOnaylandi ? 0.5 : 1,
                  cursor: evrakOnaylandi ? "not-allowed" : "pointer",
                }}
              >
                Dosya Seç
                <input
                  type="file"
                  style={{ display: "none" }}
                  onChange={handleFileSelect}
                  disabled={evrakOnaylandi}
                />
              </label>

              <button
                className="evrak-detay-yukle-btn"
                onClick={handleUpload}
                disabled={!selectedFile || evrakOnaylandi || isUploading}
              >
                {isUploading ? "Yükleniyor..." : "Evrak Yükle"}
              </button>

            </div>

            <button
              className="evrak-detay-kapat-btn"
              onClick={() => {
                setDetayEvrak(null);
                setSelectedFile(null);
                setPreviewName("");
              }}
            >
              Geri
            </button>
          </div>
        )}

      </div>
      {warning && (
        <UyariPopup
          title={warning.title}
          message={warning.message}
          type={warning.type}
          onClose={() => setWarning(null)}
        />
      )}

    </div>
  );
};

export default EvrakPopup;
